import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UserService } from './user.service';
import { RoleEnum, User } from '../../../../graphql/generated';
import {
    AppSnackbarService,
    SnackBarMessageTypeEnum,
} from '../../shared/app-snackbar/app-snackbar.service';

@Injectable({
    providedIn: 'root',
})
export class UserAdminGuard implements CanActivate {
    constructor(
        private _userService: UserService,
        private _router: Router,
        private _snackbarService: AppSnackbarService
    ) {}

    canActivate(): Observable<boolean> {
        return this._userService.getLoggedUser().pipe(
            map((user: User) => {
                if (user && user.role === RoleEnum.Admin) {
                    return true;
                } else {
                    this._snackbarService.openSnackBar(
                        'Seu usuário não tem permissão para acessar esta área.',
                        SnackBarMessageTypeEnum.error
                    );
                    this._router.navigateByUrl('/sair');
                    return false;
                }
            }),
            catchError(() => {
                this._router.navigateByUrl('/sair');
                return of(false);
            })
        );
    }
}
